var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M2.45996 10.054L6.82587 4.44073L11.5036 7.24738L16.1814 1.94592",
    stroke: "white",
    strokeWidth: 1.2474
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    cx: 2.45964,
    cy: 10.0541,
    r: 1.55925,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 6.82585,
    cy: 4.44072,
    r: 1.55925,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 16.1808,
    cy: 1.94597,
    r: 1.55925,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 5",
    cx: 11.8151,
    cy: 7.55925,
    r: 1.55925,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.b9d0c4362681af97d3fd4da15a42ef6b.svg";
export { ForwardRef as ReactComponent };